/**
 * v-debounce 登录按钮防重复点击（对齐 EB main.js Vue.directive('debounce')）
 * 点击后 1s 内禁用按钮，避免重复提交
 */

const DEBOUNCE_MS = 1000;

export default {
    mounted(el: HTMLElement) {
        const handler = () => {
            // 下一拍再禁用，避免和本次 click 抢序：native disabled 会吞掉 Element Plus 第一次点击
            window.setTimeout(() => {
                el.classList.add('is-disabled');
                if (el instanceof HTMLButtonElement) {
                    el.disabled = true;
                }
                window.setTimeout(() => {
                    if (el instanceof HTMLButtonElement) {
                        el.disabled = false;
                    }
                    el.classList.remove('is-disabled');
                }, DEBOUNCE_MS);
            }, 0);
        };
        el.addEventListener('click', handler);
        (el as any).$debounceHandler = handler;
    },
    unmounted(el: HTMLElement) {
        const handler = (el as any).$debounceHandler;
        if (handler) {
            el.removeEventListener('click', handler);
        }
    },
};
